import React from 'react'
import MissionDetail from "../../components/missionDetail/MissionDetail"
import Map from "../../components/map/Map"
import { useDrop } from 'react-dnd'
import { ItemTypes } from '../../ItemTypes'

export const MiddleSwitchContainer = ({selectedMission, setSelectedMission, missions, setmissions}) => {
    const [{canDrop, isOver}, drop] = useDrop(() => ({
        accept: ItemTypes.MISSION,
    }))

    const Dashboard = () => {
        return (
        <>
            <div className="middleBottom">Bottom, when nothing selected show Heatmap. When Gemeinde Selected, show Gemeinde Headmap. When Mission selected, show Mission Details</div>
            <div className="middleMap">
              <Map />
            </div>
        </>
        )
      }
          return (
            <>
            {selectedMission ?  
                <MissionDetail 
                  selectedMission={selectedMission} 
                  setSelectedMission={setSelectedMission}
                  missions={missions}
                  setmissions={setmissions}
                /> 
              : 
                <Dashboard />}
            </>
          )
        }
